import { SessionProfileQueryBinding, SessionProfileQuery, SessionProfileAttribute } from "./session";
import {JSDOM} from 'jsdom';


export class QueryParser
{

    /**
     * Query the document for input elements with Fountain-Analytics markup.
     * 
     * Parse input elements to data elements and return the collection.
     * 
     * @param mockWindow 
     * @returns 
     */
    public static getAll(mockWindow: JSDOM | null = null) : Array<SessionProfileQueryBinding>
    {
        // capture form inputs with the matching query markup
        const domQuery = 'input';
        let formInputs: Array<HTMLInputElement> = [];
        if (mockWindow !== null) {
            formInputs = [].slice.call(
                mockWindow.window.document.querySelectorAll(domQuery)
            );
        } else {
            formInputs = [].slice.call(
                document.querySelectorAll(domQuery)
            );
        }
        
        /**
         * Check each found form input for either:
         * - A valid session profile query (using special encoded syntax)
         * - A direct attribute reference (i.e., utmCampaignName)
         */
        let queries = [];
        const regex = new RegExp('<::.+::>');
        for(let i = 0; i < formInputs.length; i ++) {
            const value = formInputs[i].value;
            if (regex.test(value)) {
                // NOTE: Only extractFromValue when the value is encoded JSON
                const query = QueryParser.extractFromValue(value);
                if (query !== null) {
                    queries.push(
                        {
                            element: formInputs[i],
                            query: query
                        }
                    );
                }
            // Check if the value is a member of SessionProfileAttribute
            // In Operator: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/in
            } else if (value in SessionProfileAttribute) {
                const query: SessionProfileQuery = {
                    attribute: <SessionProfileAttribute>value,
                    index: 0
                };
                queries.push(
                    {
                        element: formInputs[i],
                        query: query,
                    }
                );
            }
        }
        return queries;
    }

    public static extractFromValue(inputValue: string) : SessionProfileQuery | null
    {
        // remove the tags
        inputValue = inputValue.replace('<SESSION>', '');
        inputValue = inputValue.replace('</SESSION>', '');
        inputValue = inputValue.replace(/<::/, '{');
        inputValue = inputValue.replace(/::>/, '}');
        inputValue = inputValue.replace(/;/g, '"');
        return QueryParser.extract(inputValue);
    }

    public static extract(jsonQuery: string) : SessionProfileQuery | null
    {
        try {
            const query = JSON.parse(jsonQuery);
            const queryIsDefined = typeof(query['attribute']) !== 'undefined';
            const indexIsDefined = typeof(query['index']) !== 'undefined';
            if (queryIsDefined && indexIsDefined) {
                return query;
            }
            return null;    
        } catch (exception) {
            console.error(exception);
            return null;
        }
    }

}